module.exports = __webpack_public_path__ + "img/deliveries.265244ec.png";